import TaxTablePage from "../../pages/legacy/taxTable/TaxTablePage";

const route = {
  key: "taxTable",
  path: "/legacy/tax-table",
  component: TaxTablePage,
  private: true,
  layout: "main",
  icon: "faPercentage",
  group: "finance",
  order: 10,
  permission: "legacy.taxTable.read"
};

export default route;